<template>
  <div class="CourseCount">
    <div class="container-fluid background-color">
      <div class="row vertical-align height-150px">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 font-color font-size-60px">
              {{ getUserCountValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cursor-pointer tooltip1 padding-left-0Perc padding-right-0Perc">
              <i class="col-xs-2 col-xs-offset-2 col-sm-12 col-sm-offset-0 col-md-3 col-md-offset-0 col-lg-3 col-lg-offset-1 glyphicon glyphicon-info-sign margin-top-10px margin-bottom-10px padding-left-0Perc padding-right-0Perc"><span class="tooltiptext1 CourseCount font-size-10px">No. of enrollments</span></i>
            <!-- </div> -->
            <!-- <div class="col-xs-9 col-sm-12 col-md-8 col-lg-9 text-align-left padding-right-0Perc"> -->
              <h4 class="col-xs-8 col-xs-offset-0 col-sm-10 col-sm-offset-2 col-md-8 col-md-offset-0 col-lg-8 col-lg-offset-0 padding-left-0Perc padding-right-0Perc text-align-left">{{getDisplayString}}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import forEach from 'lodash/forEach'
export default {
  created: function () {
    this.usersCount()
    this.getStringToDisplay()
  },
  data: function () {
    return {
      userCount: 0,
      stringToDisplay: ''
    }
  },
  computed: {
    getSelectedCohortList: {
      get: function () {
        return this.$store.state.selectedCohorts
      }
    },
    getGroupCourseList: {
      get: function () {
        return this.$store.state.selectedGroupCourses
      }
    },
    currDashboardTabSelection: {
      get: function () {
        return this.$store.getters.currDashboardTabSelection
      }
    },
    getGCCList: {
      get: function () {
        return this.$store.state.gccData.CoursesData
      }
    },
    getUserCountValue: {
      get: function () {
        return this.userCount
      }
    },
    getDisplayString: {
      get: function () {
        return this.stringToDisplay
      }
    }
  },
  methods: {
    usersCount: function () {
      this.userCount = 0
      switch (this.currDashboardTabSelection) {
        default:
        case 1:
          this.userCount = (this.$store.state.selectedGroupCourses.length > 0) ? this.$store.getters.filteredStats.length : 0
          break
        case 2:
          forEach(this.getSelectedCohortList, (obj) => {
            if (obj.isSelected) {
              this.userCount += parseInt(obj.TotalUsers)
            }
          })
          break
      }
    },
    getStringToDisplay: function () {
      // AK: Used to add post String after User count
      if (this.getUserCountValue > 1) {
        this.stringToDisplay = 'ENROLLMENTS'
      } else {
        this.stringToDisplay = 'ENROLLMENT'
      }
    }
  },
  watch: {
    getSelectedCohortList: function (newVal, oldVal) {
      this.usersCount()
      this.getStringToDisplay()
    }
  },

  name: 'UserCount'
}
</script>
<style scoped>
.CourseCount {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.color-red{
  border: 1px solid red;
}
.height-65px{
 height: 65px;
}
.height-150px{
 height: 175px;
}
.width-170px{
  width: 170px;
}
.border-1px{
    border: 1px solid #ccc;
}
.float-left{
  float: left;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.background-color{
  background-color:#fafafa;
}
.font-color{
  color:#27345B !important;
}
.font-size-60px{
  font-size: 60px;
}
.text-align-right{
  text-align:right;
}
.text-align-left{
  text-align:left;
}
.padding-left-5Perc{
  padding-left:5%;
}
.padding-left-0Perc{
  padding-left:0%;
}
 .padding-right-0Perc{
  padding-right:0%;
}
.padding-right-13Perc{
  padding-right:13%;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.cursor-pointer {
  cursor: pointer;
}
.tooltip1 {
    position: relative;
    display: inline-block;
    /* border-bottom: 1px dotted black; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    width: 120px;
    background-color: #696969;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    top: 150%;
    left: 50%;
    margin-left: -60px;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1 :hover .tooltiptext1 {
    visibility: visible;
}
.line-height{
  line-height: 0;
}
.font-size-16px{
  font-size:16px;
}
.font-size-10px{
  font-size:12px;
}
.padding-left-10px{
  padding-left:10px;
}
.font-size-100Perc{
  font-size:100%;
}
.font-weight-bold{
  font-weight:500;
}
h4{
 font-family: inherit;
 font-weight: 500;
 line-height: 1.1;
 color:inherit;
 font-size:1em;
}
.margin-top-10px{
  margin-top: 10px;
}
.margin-bottom-10px{
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard_v2/UserCount.vue